import React from 'react';
import { MdClose } from 'react-icons/md';
import { FaArrowRight } from 'react-icons/fa';
import * as nativeEvents from '../../../Helper/native';

const ValentinesBrands = ({ brands = [], onBack }) => {
  const handleBrandClick = (merchantId) => {
    if (merchantId) {
      nativeEvents.goMerchant(merchantId);
    }
  };

  const getTodayLabel = () => {
    const today = new Date();
    const day = today.getDate();
    const monthIndex = today.getMonth(); // 0-based
    const year = today.getFullYear();

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const getOrdinal = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${months[monthIndex]}, ${year}`;
  };

  return (
    <div className="valentinesBrand-banner">
      {/* <div className="valentines-headerCta">
        <button
          className="valentinesBrand-closeCta"
          onClick={() => {
            nativeEvents.goBack();
            onBack();
          }}
        >
          <MdClose size={24} color="#FFFFFF" />
        </button>
      </div> */}
      <div className="valentines-brands-container">
        <div className="valentines-brands-title">
          {getTodayLabel()}
        </div>
        <div className="valentine-brands-subtitle" style={{ fontSize: '24px !important' }}>
          Today's Surprise Brands
        </div>
        {brands && brands.length === 0 ? (
          <div className="valentines-brands-empty" style={{ color: '#FFFFFF', textAlign: 'center', padding: '40px 20px' }}>
            No brands available at the moment.
          </div>
        ) : (
          <div className="valentines-brands-grid">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="valentines-brand-card"
                style={{
                  background: brand.bgColor,
                  border: brand.borderColor,
                }}
                onClick={() => handleBrandClick(brand.merchantId)}
              >
                <div className="valentines-brand-image-container">
                  <img
                    className="valentines-brand-image"
                    alt=""
                    src={brand.imgUrl}
                  />
                </div>
                <div
                  className="valentines-brand-reward"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (brand.merchantId) {
                      nativeEvents.goMerchant(brand.merchantId);
                    }
                  }}
                >
                   {brand.flatReward}% Rewards
                  <FaArrowRight style={{ marginLeft: '10px' }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <style>{`
        .valentines-brands-container {
          padding: 20px;
          margin-top: 20px;
        }
        .valentines-brands-title {
          font-size: 18px !important;
          font-weight: 700;
          color: #FFFFFF;
          text-align: center;
          margin-bottom: 10px;
        }
        .valentines-brands-subtitle {
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          margin-bottom: 30px;
          opacity: 0.9;
        }
        .valentines-brands-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 22px;
          margin-bottom: 30px;
          justify-content: center;
          justify-items: center;
          margin-top: 100px;
        }
        .valentines-brand-card {
          border-radius: 12px;
          padding: 26px 9px 12px 9px;
          cursor: pointer;
          box-shadow: 4px 8px 24px 0px rgba(233, 30, 99, 0.6);
          transition: transform 0.2s;
        }
        .valentines-brand-card:active {
          transform: scale(0.95);
        }
        .valentines-brand-image-container {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 12px;
        }
        .valentines-brand-image {
          width: 156px;
          height: auto;
          max-height: 80px;
          object-fit: contain;
        }
        .valentines-brand-reward {
          color: #F5DCBC !important;
          font-size: 14px;
          font-weight: 600;
          background-color: #000000 !important;
          padding: 5px 9px;
          border-radius: 100px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .valentines-back-button {
          width: 100%;
          padding: 14px 20px;
          border-radius: 100px;
          border: 2px solid #E91E63;
          background: transparent;
          color: #E91E63;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 20px;
        }
        .valentines-back-button:active {
          opacity: 0.8;
        }
      `}</style>
    </div>
  );
};

export default ValentinesBrands;
